import { debounce } from 'es-toolkit/compat';

// Expose debounce to the global window object
window.debounce = debounce;

export default debounce; // eslint-disable-line
